import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { FeaturesBaseComponent } from "src/app/features-common/components/features-base.component";
import { HttpParams } from "@angular/common/http";
import { Params, Router } from "@angular/router";
import Swal from "sweetalert2";
import { ReportsService } from "src/app/features/reports/reports.service";
import { MatDialog } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { DialogComponent } from "src/app/features-common/components/dialog/dialog.component";
import { MatTabGroup } from "@angular/material/tabs";
import { CurrencyPipe, formatDate } from "@angular/common";
import * as moment from "moment";
import { JwtHelperService } from "@auth0/angular-jwt";
import { AdminViewService } from "src/app/framework/services/admin-view.service";
const helper = new JwtHelperService();

function headerHeightGetter() {
  var columnHeaderTexts = document.querySelectorAll(".ag-header-cell-text");

  var columnHeaderTextsArray = [];

  columnHeaderTexts.forEach((node) => columnHeaderTextsArray.push(node));

  var clientHeights = columnHeaderTextsArray.map(
    (headerText) => headerText.clientHeight
  );
  var tallestHeaderTextHeight = Math.max(...clientHeights);
  return tallestHeaderTextHeight;
}
@Component({
  selector: "app-sales-summary",
  templateUrl: "./sales-summary.component.html",
  styleUrls: ["./sales-summary.component.scss"],
  providers: [CurrencyPipe],
})
export class SalesSummaryComponent
  extends FeaturesBaseComponent
  implements OnInit {
  @Input() sales;
  @Input() summary;

  isRowSelected: boolean = false;
  searchValue: any;

  columnDefs: any;
  rowData: any = [];
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  isLogSelected: boolean;
  userRole: string = "";

  isButtonDisabled:boolean
  //summary:  Array<any>;

  minFromDate;
  maxDate;
  minToDate;
  startDate;
  endDate;
  defaultColDef: {
    flex: number;
    resizable: boolean;
    wrapText: boolean;
    autoHeight: boolean;
    sortable: boolean;
    headerComponentParams: { template: string };
  };

  constructor(
    private router: Router,
    private reportsService: ReportsService,
    private currencyPipe: CurrencyPipe,
    private adminViewServices:AdminViewService
  ) {
    super();
    const token: string = localStorage.getItem("accessToken");
    let decoded_token: any = helper.decodeToken(token);
    this.userRole = decoded_token.role;
    this.setGrid();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["sales"]) {
      this.sales = changes["sales"].currentValue;
      this.rowData = this.sales;
    }
    if (changes["summary"]) {
      this.summary = changes["summary"].currentValue;
    }
  }

  setGrid() {


    this.columnDefs = [
      { field: "productId", headerName: "id", width: 210, hide: true },
      {
        field: "retailerAccount",
        headerName: "Retailer Account #",
        width: 250,
      },
      { field: "storeName", headerName: "Store Name", width: 210 },
      { field: "mobileNumber", headerName: "Mobile Number", width: 220 },
      /* { field: "productName", headerName: "Product Name", width: 250 },
       { field: "productType", headerName: "Product Type", width: 220 },
       { field: "carrier", headerName: "Carrier", width: 130 },*/
      { field: "address", headerName: "Address", width: 160 },
      { field: "state", headerName: "State", width: 200 },
      { field: "city", headerName: "City", width: 180 },
      {
        field: "salesDistributorAssigned",
        headerName: "Sales Distributor Assigned",
        width: 280,
      },
      {
        field: "salesJanuary",
        headerName: `Sales in Jan ${this.headerResolver(1)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesFebruary",
        headerName: `Sales in Feb ${this.headerResolver(2)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesMmarch",
        headerName: `Sales in Mar ${this.headerResolver(3)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesApril",
        headerName: `Sales in Apr ${this.headerResolver(4)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesMay",
        headerName: `Sales in May ${this.headerResolver(5)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesJune",
        headerName: `Sales in Jun ${this.headerResolver(6)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesJuly",
        headerName: `Sales in Jul ${this.headerResolver(7)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesAugust",
        headerName: `Sales in Aug ${this.headerResolver(8)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesSeptember",
        headerName: `Sales in Sep ${this.headerResolver(9)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesOctober",
        headerName: `Sales in Oct ${this.headerResolver(10)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesNovember",
        headerName: `Sales in Nov ${this.headerResolver(11)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
      {
        field: "salesDecember",
        headerName: `Sales in Dec ${this.headerResolver(12)}`,
        width: 220,
        cellRenderer: (data) => {
          return this.currencyPipe.transform(data.value);
        },
      },
    ];

    this.defaultColDef = {
      flex: 1,
      resizable: true,
      wrapText: true,
      autoHeight: true,
      sortable: true,
      headerComponentParams: {
        template:
          '<div class="ag-cell-label-container" role="presentation">' +
          '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
          '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
          '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
          '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
          '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
          '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
          '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
          '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
          "  </div>" +
          "</div>",
      },
    };
    //this.rowData = []
  }
  headerResolver(arg: number) {
    let currentMonth = new Date().getMonth() + 1;
    console.log(arg <= currentMonth ? new Date().getFullYear() : new Date().getFullYear() - 1);

    return arg <= currentMonth ? new Date().getFullYear() : new Date().getFullYear() - 1;
  }
  exportData() {
    let header = this.columnDefs.map((columnDef) => {
      let headerName = columnDef.headerName;
      return headerName;
    });
    let params: any = {
      fileName: "Sales-Summary.csv",
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs
        .map((c) => c.field || c.colId)
        .filter((c) => !!c),
    };
    params.customHeader = header.join(params.columnSeparator);
    params.processCellCallback = (cellParams) => {
      // 
      if (cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      } else if (
        (cellParams && cellParams.column.colId === "salesJanuary") ||
        cellParams.column.colId === "salesFebruary" ||
        cellParams.column.colId === "salesMmarch" ||
        cellParams.column.colId === "salesApril" ||
        cellParams.column.colId === "salesMay" ||
        cellParams.column.colId === "salesJune" ||
        cellParams.column.colId === "salesJuly" ||
        cellParams.column.colId === "salesAugust" ||
        cellParams.column.colId === "salesSeptember" ||
        cellParams.column.colId === "salesOctober" ||
        cellParams.column.colId === "salesNovember" ||
        cellParams.column.colId === "salesDecember"
      ) {
        return this.currencyPipe.transform(cellParams.value);
      } else return cellParams.value; // no formatting
    };
    this.gridApi.exportDataAsCsv(params);
  }
  ngOnInit(): void {
    super.ngOnInit();
     this.adminViewServices.checkAdminVRole().subscribe((res) => {
      this.isButtonDisabled = res
    })

  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }
  headerHeightSetter(e) {
    var padding = 20;
    var height = headerHeightGetter() + padding;
    this.gridApi.setHeaderHeight(height);
    this.gridApi.resetRowHeights();
  }
  onSelectionChanged(e) {
    //;
    this.selectedRows = this.gridApi.getSelectedRows();
    if (
      this.selectedRows &&
      this.selectedRows != [] &&
      this.selectedRows.length! > 0
    ) {
      this.isLogSelected = true;
      return;
    }
    this.isLogSelected = false;
  }

  changeFromDate(e) {
    this.minToDate = e.value;
    this.startDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.endDate != null && this.endDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  changeToDate(e) {
    this.endDate = formatDate(e.value, "yyyy-MM-dd", "en");
    if (this.startDate != null && this.startDate != undefined) {
      this.getDateChangeResult(this.startDate, this.endDate);
    }
  }
  getDateChangeResult(startDate, endDate) {
    let params: any = new HttpParams()
      .set("startDate", startDate)
      .set("endDate", endDate);
    this.reportsService.getsalesSummary(params).subscribe((res) => {
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        this.summary = resData;
        this.reportsService.getsales(params).subscribe((res) => {
          let resData: any = res;
          if (resData.httpcode == 200) {
            resData = resData.data;
            this.setRowData(res["data"]);
            this.sales = resData;
          }
        });
      }
    });
  }

  setRowData(rowData: any) {
    this.rowData = rowData;
  }
}
